import { administrationRequests } from "api/administrationApi";
import ScheduledItemFields from "./ScheduledItemFields";

const PracticeFields = props => (
  <ScheduledItemFields
    {...props}
    source="practiceId"
    reference={administrationRequests.getPracticesSelect()}
    label="Учебна практика"
  />
);

export default PracticeFields;
